import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Capture the PWA install prompt globally so any page (e.g. /install) can trigger it later.
window.__deferredInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__deferredInstallPrompt = e;
  window.dispatchEvent(new Event('bwgela-installable'));
});
window.addEventListener('appinstalled', () => {
  window.__deferredInstallPrompt = null;
  window.dispatchEvent(new Event('bwgela-installed'));
});

// Drop build-time SEO snapshot tags; React renders the live metadata.
document.querySelectorAll('[data-snap]').forEach((n) => n.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Reveal the app only once React has painted and the Satoshi font is ready (prevents the text flash).
requestAnimationFrame(() => requestAnimationFrame(() => {
  window.__bwgAppMounted = true;
  if (window.__bwgFontReady) window.__bwgReady();
}));
